import { render } from "./search-filterBarComponent.vue?vue&type=template&id=68b54b8a&scoped=true"
import script from "./search-filterBarComponent.vue?vue&type=script&lang=js"
export * from "./search-filterBarComponent.vue?vue&type=script&lang=js"

import "./search-filterBarComponent.vue?vue&type=style&index=0&id=68b54b8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b54b8a"]])

export default __exports__